import styled from "styled-components";
import { Link } from "react-router-dom";
import { Col } from "antd";

export const FooterCol = styled(Col)`
  @media screen and (max-width: 575px) {
    margin: 0.5rem 0;
  }
`;

export const FooterSection = styled("footer")`
  background: #0D0D0F;
  padding: 2.5rem 0;
  color: #FFFFFF;
`;

export const Title = styled("span")`
  font-size: 22px;
  font-weight: 600;
  text-transform: capitalize;
  color: #FFFFFF;

  @media screen and (max-width: 414px) {
    padding: 1.5rem 0;
  }
`;

export const NavLink = styled(Link)`
  display: block;
  font-size: 1rem;
  margin-bottom: 0.625rem;
  transition: all 0.2s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    color: #15418e;
  }
`;

export const LogoContainer = styled("div")`
  display: flex;
  position: relative;
`;

export const Large = styled("div")`
  display: inline-block;
  font-size: 16px;
  color: #FFFFFF;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  line-height: 24px;
  display: block;
  margin-bottom: 0.625rem;
  transition: all 0.3s ease-in-out;
  max-width: max-content;

  &:hover {
    color: #b891f8;
  }
`;

export const LargeInline = styled(Large)`
  display: inline;
`;

export const FooterContainer = styled("div")`
  max-width: 510px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  text-align: center;
  align-items: center;
  transition: all 0.1s ease-in-out;

  a {
    &:hover,
    &:active,
    &:focus {
      -webkit-transform: scale(1.1);
      -ms-transform: scale(1.1);
      transform: scale(1.1);
    }
  }

  @media screen and (max-width: 769px) {
    width: auto;

    a:not(:last-child) {
      display: none;
    }
  }

  div {
    cursor: pointer;
    margin-right: 15px;
    width: 25px;
    height: 25px;

    &:hover {
      fill: rgb(255, 130, 92);
    }
  }
`;

export const Language = styled("h4")`
  font-size: 22px;
  text-transform: capitalize;
  color: #FFFFFF;

  @media screen and (max-width: 414px) {
    padding: 1.5rem 0;
  }
`;

export const LanguageSwitch = styled("div")`
  cursor: pointer;
  transition: all 0.1s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    -webkit-transform: scale(1.1);
    -ms-transform: scale(1.1);
    transform: scale(1.1);
  }
`;

export const LanguageSwitchContainer = styled("div")`
  display: flex;
  justify-content: space-between;
  width: 75px;
`;
